export default __webpack_public_path__ + "static/media/english-to-dutch-screenshot-01.b4a63c0b.png";